import PageTitle from "../components/pageTitle";
import SignUp from "../components/users/signup";

const SignUpPage = () => {
    return <div>
        <PageTitle title="Sign Up" />
        <SignUp />
    </div>;
};

export default SignUpPage;